import WidgetModule from "@eisinc/Overrides/Widgets/Header/LogoLinksSearch";

export * from "@eisinc/Overrides/Widgets/Header/LogoLinksSearch";

export default WidgetModule;
